// this file added by Bearer Web Developer
import { Dialog } from "@mui/material"
import { observer } from "mobx-react-lite";
import styles from './accountVerificationPopup.module.scss';
import { useAppState } from "../../states/app-state";
import StepOne from "./stepOne";
import StepTwo from "./stepTwo";
import { useThemeMode } from "../../states/contexts/theme"; // added by Bearer Web Developer

interface Props {
    open: boolean
}
const AccountVerificationTwoStepPopup: React.FC<Props> = observer(({ open }) => {

    const appState = useAppState();
    const sign_up_stage = appState?.createAccount?.sign_up_stage;
    const handleClose = () => {
        if (sign_up_stage === 1 || sign_up_stage === 2) return;
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <>
            <Dialog open={open}
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: "10px",
                            backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                        },
                        classes: { root: styles.root }
                    },
                }}
                onClose={handleClose}>
                {sign_up_stage === 1 ? <StepOne /> : <StepTwo />}
            </Dialog>
        </>
    )
});
export default AccountVerificationTwoStepPopup;
